// extracted by mini-css-extract-plugin
export default {"root":"ListWrapper_root__RQMzo"};